import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Dialog, IconButton } from '@material-ui/core';

import IconClose from 'src/assets/icons/Close';
import { useStyles } from './useStyles';

export const Popup = ({
  open,
  onClose,
  classes,
  testId,
  children,
  isCloseDisabled,
  isCloseHidden,
  ...restProps
}) => {
  const styles = useStyles();

  const { closeButton, dialog, ...otherClasses } = classes;

  return (
    <Dialog
      className={cx(styles.root, dialog)}
      classes={otherClasses}
      open={open}
      onClose={onClose}
      data-testid={testId}
      {...restProps}
    >
      {!isCloseHidden && (
        <IconButton
          className={cx(styles.buttonClose, closeButton)}
          onClick={onClose}
          disabled={isCloseDisabled}
        >
          <IconClose />
        </IconButton>
      )}
      {children}
    </Dialog>
  );
};

Popup.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  classes: PropTypes.shape(),
  testId: PropTypes.string,
  children: PropTypes.node.isRequired,
  isCloseDisabled: PropTypes.bool,
  isCloseHidden: PropTypes.bool,
};

Popup.defaultProps = {
  classes: undefined,
  testId: undefined,
  isCloseDisabled: false,
  isCloseHidden: false,
  onClose: undefined,
};
